import React, { useEffect, useState } from 'react';
import Navbar from '../navbar/Navbar';
import { Typography, TextField, Button, Autocomplete } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Select from "react-select";
import { apiCall, downloadApiCall, searchApiCall } from '../../../service';
import config from '../../config';
import Error from '../../utils/Error';
import Success from '../../utils/Success';
import { urlHelper } from '../../utils/urlHelpers';
import "./punctuality.css"
import MonthDayBasedTable from './MonthDayBasedTable';
import OriginBasedTable from './OriginBasedTable';
import WeekBasedTable from './WeekBasedTable';

const PunctualityReport = () => {
    const [allPunctualityReportData, setAllPunctualityReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    const [dayWiseData, setDayWiseData] = useState('Day Wise')
    const [vehicleWiseData, setVehicleWiseData] = useState('')
    const [inputValueNo, setInputValueNo] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [specificDate, setSpecificDate] = useState(null)
    const [originDate, setOriginDate] = useState(new Date(Date.now() - 86400000));

    const [dayValueError, setDayValueError] = useState('')
    const [vehicleValueError, setVehicleValueError] = useState('')
    const [startDateError, setStartDateError] = useState('')
    const [endDateError, setEndDateError] = useState('')
    const [specificDateError, setSpecificDateError] = useState('')
    const [inputValueError, setInputValueError] = useState('')
    const [originError, setOriginError] = useState('');
    const [destinationError, setDestinationError] = useState('')
    const [buttonClicked, setButtonClicked] = useState(false)
    const [downloadLoading, setDownloadLoading] = useState(false);

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [dataSuccessMessage, setDataSuccessMessage] = useState(false);
    const [dataErrorMessage, setDataErrorMessage] = useState(false);


    const [vehicleServiceType, setVehicleServiceType] = useState("");
    const [vehicleServiceData, setVehicleServiceData] = useState([]);


    const [originData, setOriginData] = useState([])
    const [selectedOrigin, setSelectedOrigin] = useState("")
    const [autocompleteOrigin, setAutocompleteOrigin] = useState("");

    const [destinationData, setDestinationData] = useState([]);
    const [selectedDestination, setSelectedDestination] = useState("")
    const [autocompleteDestination, setAutocompleteDestination] = useState("");
    const [showFilter, setShowFilter] = useState(false);


    useEffect(() => {
        const fetchOriginData = async () => {
            if (autocompleteOrigin.length < 3) {
                setOriginData([]);
                return;
            }

            const endpoint = urlHelper(config.apiEndpoints.searchCity.url, {
                city: autocompleteOrigin.slice(0, 4),
            });

            try {
                const payload = {
                    host: config.apiEndpoints.searchCity.host,
                    endPoint: endpoint,
                    method: "GET",
                    headers: {
                        "Cache-Control": "no-cache",
                        Pragma: "no-cache",
                        Expires: "0",
                    },
                };

                const response = await searchApiCall(payload);
                if (response && response.data) {
                    const originNames = response.data.map(item => item._source.name);
                    setOriginData(originNames);
                }
            } catch (error) {
                console.error("Error fetching origin data:", error);
            }
        };

        fetchOriginData();
    }, [autocompleteOrigin]);

    // Effect for fetching destination data
    useEffect(() => {
        const fetchDestinationData = async () => {
            if (autocompleteDestination.length < 3) {
                setDestinationData([]);
                return;
            }

            const endpoint = urlHelper(config.apiEndpoints.searchCity.url, {
                city: autocompleteDestination.slice(0, 4),
            });

            try {
                const payload = {
                    host: config.apiEndpoints.searchCity.host,
                    endPoint: endpoint,
                    method: "GET",
                    headers: {
                        "Cache-Control": "no-cache",
                        Pragma: "no-cache",
                        Expires: "0",
                    },
                };

                const response = await searchApiCall(payload);
                if (response && response.data) {
                    const destinationNames = response.data.map(item => item._source.name);
                    setDestinationData(destinationNames);
                }
            } catch (error) {
                console.error("Error fetching destination data:", error);
            }
        };

        fetchDestinationData();
    }, [autocompleteDestination]);

    const handleOriginInputChange = (event, newInputValue) => {
        setAutocompleteOrigin(newInputValue);
    };

    const handleOriginValueChange = (event, newValue) => {
        if (newValue) {
            let selectedCityName = originData.find(
                (item) => item === newValue
            )
            if (selectedCityName) {
                setSelectedOrigin(selectedCityName)
                setOriginData([selectedCityName]);
            }
        }
    };
    const handleDestinationInputChange = (event, newInputValue) => {
        setAutocompleteDestination(newInputValue);
    };

    const handleDestinationValueChange = (event, newValue) => {
        if (newValue) {
            let selectedCityName = destinationData.find(
                (item) => item === newValue
            )
            if (selectedCityName) {
                setSelectedDestination(selectedCityName)
                setDestinationData([selectedCityName]);
            }
        }
    };

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    useEffect(() => {
        setLoading(false)
    }, [])


    const dayWise = [
        { value: 'Day Wise', label: 'Day Wise' },
        { value: 'Week Wise', label: 'Week Wise' },
        { value: 'Monthly Wise', label: 'Monthly Wise' },
        { value: 'Origin Wise', label: 'Origin-Destination Wise' }
    ]
    const vehicleWise = [
        { value: 'vehicle', label: 'Vehicle Wise' },
        { value: 'service', label: 'Service Id Wise' },
    ]

    const getDaysDifference = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
        const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        // console.log("Difference" , diffDays)
        return diffDays;
    };

    const handleStartDate = (date) => {
        setStartDate(date);
        setStartDateError('');
        if (endDate && getDaysDifference(date, endDate) <= 30) {
            setEndDateError('');
        }
    };

    const handleEndDate = (date) => {
        setEndDate(date);
        setEndDateError('');
        if (endDate && getDaysDifference(date, endDate) <= 30) {
            setEndDateError('');
        }
    };

    const handleSpecificDate = async (date) => {
        setSpecificDate(date);
        setSpecificDateError('');
        if (dayWiseData === "Day Wise" && vehicleServiceType === "vehicle") {
            try {
                const payload = {
                    host: config.apiEndpoints.getDailyData.host,
                    endPoint: config.apiEndpoints.getDailyData.url,
                    method: "POST",
                    body: {
                        date: formatDate(date),
                        type: vehicleServiceType
                    },
                };
                const response = await apiCall(payload)
                const result = response.data.map((data) => data.Vehicle_no)
                const formattedResult = result.map((vehicleNo) => ({
                    value: vehicleNo,
                    label: String(vehicleNo)
                }));
                setVehicleServiceData(formattedResult);
            } catch (error) {

            }
        }
        else if (dayWiseData === "Day Wise" && vehicleServiceType === "service") {
            try {
                const payload = {
                    host: config.apiEndpoints.getDailyData.host,
                    endPoint: config.apiEndpoints.getDailyData.url,
                    method: "POST",
                    body: {
                        date: formatDate(date),
                        type: vehicleServiceType
                    },
                };
                const response = await apiCall(payload)
                const result = response.data.map((data) => data.service_id)
                const formattedResult = result.map((serviceId) => ({
                    value: serviceId,
                    label: String(serviceId)
                }));
                setVehicleServiceData(formattedResult);
            } catch (error) {

            }
        }
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const renderErrorMessage = (errorState) => {
        return (
            errorState && (
                <Typography variant="body2" color="error">
                    {errorState}
                </Typography>
            )
        );
    };

    const handleShowAllReports = async () => {
        setButtonClicked(true);
        setDayValueError('');
        setVehicleValueError('');
        setStartDateError('');
        setEndDateError('');
        setSpecificDateError('');
        setInputValueError('');
        setAllPunctualityReportData([]);
        // setAutocompleteOrigin("")
        // setAutocompleteDestination("")
        // setInputValueNo(null)

        if (!dayWiseData) {
            setDayValueError("Day wise/Monthly wise is required");
            setButtonClicked(false);
            setTimeout(() => setDayValueError(''), 2000);
            return;
        }

        if (dayWiseData === 'Day Wise' || dayWiseData === 'Week Wise' || dayWiseData === 'Monthly Wise') {
            if (!vehicleWiseData) {
                setVehicleValueError("Vehicle wise/Service Id wise is required");
                setButtonClicked(false);
                setTimeout(() => setVehicleValueError(''), 2000);
                return;
            }
        }

        if (dayWiseData === 'Day Wise') {
            if (!specificDate) {
                setSpecificDateError("Specific date is required for Day Wise");
                setButtonClicked(false);
                setTimeout(() => setSpecificDateError(''), 2000);
                return;
            }
        }
        if (dayWiseData === 'Origin Wise') {
            if (autocompleteOrigin === "") {
                setOriginError("Origin is required for Origin Wise");
                setButtonClicked(false);
                setTimeout(() => setOriginError(''), 2000);
                return;
            }
        }
        if (dayWiseData === 'Origin Wise') {
            if (autocompleteDestination === "") {
                setDestinationError("Destination is required for Origin Wise");
                setButtonClicked(false);
                setTimeout(() => setDestinationError(''), 2000);
                return;
            }
        }
        if (dayWiseData === 'Origin Wise') {
            if (!originDate) {
                setSpecificDateError("Specific date is required for Origin Wise");
                setButtonClicked(false);
                setTimeout(() => setSpecificDateError(''), 2000);
                return;
            }
        }
        if (dayWiseData === 'Week Wise') {
            if (!startDate) {
                setStartDateError("Start Date is required for Monthly Wise");
                setButtonClicked(false);
                setTimeout(() => setStartDateError(''), 2000);
                return;
            }
            if (!endDate) {
                setEndDateError("End Date is required for Monthly Wise");
                setButtonClicked(false);
                setTimeout(() => setEndDateError(''), 2000);
                return;
            }

            if (getDaysDifference(startDate, endDate) >= 7) {
                setEndDateError("Start and end dates must be within 7 days.");
                setButtonClicked(false);
                setTimeout(() => setEndDateError(''), 2000);
                return;
            }
        }

        if (dayWiseData === 'Monthly Wise') {
            if (!startDate) {
                setStartDateError("Start Date is required for Monthly Wise");
                setButtonClicked(false);
                setTimeout(() => setStartDateError(''), 2000);
                return;
            }
            if (!endDate) {
                setEndDateError("End Date is required for Monthly Wise");
                setButtonClicked(false);
                setTimeout(() => setEndDateError(''), 2000);
                return;
            }

            if (getDaysDifference(startDate, endDate) > 30) {
                setEndDateError("Start and end dates must be within 30 days.");
                setButtonClicked(false);
                setTimeout(() => setEndDateError(''), 2000);
                return;
            }
            if (!inputValueNo) {
                setInputValueError("Vehicle/Service ID is required");
                setButtonClicked(false);
                setTimeout(() => setInputValueError(''), 2000);
                return;
            }
        }

        if (dayWiseData === "Monthly Wise" || dayWiseData === "Day Wise") {
            try {
                const payload = {
                    host: config.apiEndpoints.liveTrackingReport.host,
                    endPoint: config.apiEndpoints.liveTrackingReport.url,
                    method: "POST",
                    body: {
                        ...(inputValueNo !== null && vehicleWiseData === 'vehicle' && { vehicleNo: inputValueNo }),
                        ...(inputValueNo !== null && vehicleWiseData === 'service' && { serviceId: inputValueNo }),
                        ...(dayWiseData === 'Day Wise' && { date: formatDate(specificDate) }),
                        ...((dayWiseData === 'Monthly Wise' || dayWiseData === 'Week Wise') && { from: formatDate(startDate), to: formatDate(endDate) }),
                    },
                };
                const response = await apiCall(payload)
                if (response.status) {
                    setDataSuccessMessage(true);
                    setSuccessMessage(response.message);

                    const allReportData = response.data.map((data) => ({
                        jobId: data.id ? data.id : "N/A",
                        tripId: data.trip_id ? data.trip_id : "N/A",
                        serviceID: data.service_id ? data.service_id : "N/A",
                        vehicleNo: data.vehicle_no ? data.vehicle_no : "N/A",
                        hopNumbersOnTimeArrival: data.onTimeArrCount ? data.onTimeArrCount : "N/A",
                        hopNumbersDelayedArrival: data.lateArrCount ? data.lateArrCount : "N/A",
                        onTimeArrivalPercentage: `${data.onTimeArrPerc.toFixed(2)}%` ? `${data.onTimeArrPerc.toFixed(2)}%` : "N/A",
                        hopNumbersOnTimeDeparture: data.onTimeDepCount ? data.onTimeDepCount : "N/A",
                        hopNumbersDelayedDeparture: data.lateDepCount ? data.lateDepCount : "N/A",
                        onTimeDeparturePercentage: `${data.onTimeDepPerc.toFixed(2)}%` ? `${data.onTimeDepPerc.toFixed(2)}%` : "N/A",
                        overAllPunctualityPercentage: `${data.overAllPuch.toFixed(2)}%` ? `${data.overAllPuch.toFixed(2)}%` : "N/A",
                    }));


                    setButtonClicked(false);
                    setAllPunctualityReportData(allReportData);

                    setTimeout(() => {
                        setSuccessMessage('');
                        setDataSuccessMessage(false);
                    }, 1000);
                } else {
                    setDataErrorMessage(true);
                    setErrorMessage(response.message || "Something went wrong.");
                    setButtonClicked(false);

                    setTimeout(() => {
                        setErrorMessage('');
                        setDataErrorMessage(false);
                    }, 1000);
                }
            } catch (error) {
                setDataErrorMessage(true);
                setErrorMessage(error.message || "Something went wrong.");
                setButtonClicked(false);

                setTimeout(() => {
                    setErrorMessage('');
                    setDataErrorMessage(false);
                }, 1000);
            }
        }
        if (dayWiseData === "Origin Wise") {
            try {
                const payload = {
                    host: config.apiEndpoints.liveTrackingReportOrigin.host,
                    endPoint: config.apiEndpoints.liveTrackingReportOrigin.url,
                    method: "POST",
                    body: {
                        ...((dayWiseData === 'Origin Wise') && { origin: selectedOrigin }),
                        ...(dayWiseData === 'Origin Wise' && { destination: selectedDestination }),
                        ...((dayWiseData === 'Origin Wise') && { date: formatDate(originDate) }),
                    },
                };

                // console.log("paylaod", payload)
                const response = await apiCall(payload)
                // console.log("response", response)
                if (response.status) {
                    setDataSuccessMessage(true);
                    setSuccessMessage(response.message);

                    const allReportData = response.data.map((data) => ({
                        jobId: data.id ? data.id : "N/A",
                        tripId: data.trip_id ? data.trip_id : "N/A",
                        serviceID: data.service_id ? data.service_id : "N/A",
                        serviceName: data.service_name ? data.service_name : "N/A",
                        originCityName: data.origin.city ? data.origin.city : "N/A",
                        originEnter: data.origin.enter ? data.origin.enter.replace('T', ' ').split('.')[0] : "N/A",
                        originExit: data.origin.exit ? data.origin.exit : "N/A",
                        destinationCityName: data.destination.city ? data.destination.city : "N/A",
                        destinationEnter: data.destination.enter ? data.destination.enter.replace('T', ' ').split('.')[0] : "N/A",
                        destinationExit: data.destination.exit ? data.destination.exit.replace('T', ' ').split('.')[0] : "N/A",
                        vehicleNo: data.vehicle_no ? data.vehicle_no : "N/A",
                        hopNumbersOnTimeArrival: data.onTimeArrCount ? data.onTimeArrCount : "N/A",
                        hopNumbersDelayedArrival: data.lateArrCount ? data.lateArrCount : "N/A",
                        onTimeArrivalPercentage: `${data.onTimeArrPerc.toFixed(2)}%` ? `${data.onTimeArrPerc.toFixed(2)}%` : "N/A",
                        hopNumbersOnTimeDeparture: data.onTimeDepCount ? data.onTimeDepCount : "N/A",
                        hopNumbersDelayedDeparture: data.lateDepCount ? data.lateDepCount : "N/A",
                        onTimeDeparturePercentage: `${data.onTimeDepPerc.toFixed(2)}%` ? `${data.onTimeDepPerc.toFixed(2)}%` : "N/A",
                        overAllPunctualityPercentage: `${data.overAllPuch.toFixed(2)}%` ? `${data.overAllPuch.toFixed(2)}%` : "N/A",
                    }));


                    setButtonClicked(false);
                    setAllPunctualityReportData(allReportData);

                    setTimeout(() => {
                        setSuccessMessage('');
                        setDataSuccessMessage(false);
                    }, 1000);
                } else {
                    setDataErrorMessage(true);
                    setErrorMessage(response.message || "Something went wrong.");
                    setButtonClicked(false);

                    setTimeout(() => {
                        setErrorMessage('');
                        setDataErrorMessage(false);
                    }, 1000);
                }
            } catch (error) {
                setDataErrorMessage(true);
                setErrorMessage(error.message || "Something went wrong.");
                setButtonClicked(false);

                setTimeout(() => {
                    setErrorMessage('');
                    setDataErrorMessage(false);
                }, 1000);
            }
        }
        else if (dayWiseData === "Week Wise") {
            try {
                const payload = {
                    host: config.apiEndpoints.liveTrackingReportWeek.host,
                    endPoint: config.apiEndpoints.liveTrackingReportWeek.url,
                    method: "POST",
                    body: {
                        type: vehicleWiseData,
                        ...((dayWiseData === 'Week Wise') && { from: formatDate(startDate), to: formatDate(endDate) }),
                    },
                };
                const response = await apiCall(payload)
                if (response.status) {
                    setDataSuccessMessage(true);
                    setSuccessMessage(response.message);
                    // console.log("response", response.data)
                    const allReportData = response.data.map((data) => ({
                        jobId: data.jobId ? data.jobId : "N/A",
                        tripId: data.trip_id ? data.trip_id : "N/A",
                        serviceID: data.serviceId ? data.serviceId : "N/A",
                        vehicleNo: data.vehicle ? data.vehicle : "N/A",
                        serviceName: data.serviceName ? data.serviceName : "N/A",
                        from: data.from ? data.from : "N/A",
                        to: data.to ? data.to : "N/A",
                        // hopNumbersOnTimeArrival: data.onTimeArrCount ? data.onTimeArrCount : "N/A",
                        // hopNumbersDelayedArrival: data.lateArrCount ? data.lateArrCount : "N/A",
                        // onTimeArrivalPercentage: `${data.onTimeArrPerc.toFixed(2)}%` ? `${data.onTimeArrPerc.toFixed(2)}%` : "N/A",
                        // hopNumbersOnTimeDeparture: data.onTimeDepCount ? data.onTimeDepCount : "N/A",
                        // hopNumbersDelayedDeparture: data.lateDepCount ? data.lateDepCount : "N/A",
                        // onTimeDeparturePercentage: `${data.onTimeDepPerc.toFixed(2)}%` ? `${data.onTimeDepPerc.toFixed(2)}%` : "N/A",
                        // overAllPunctualityPercentage: `${data.overAllPuch.toFixed(2)}%` ? `${data.overAllPuch.toFixed(2)}%` : "N/A",
                    }));


                    setButtonClicked(false);
                    setAllPunctualityReportData(allReportData);

                    setTimeout(() => {
                        setSuccessMessage('');
                        setDataSuccessMessage(false);
                    }, 1000);
                } else {
                    setDataErrorMessage(true);
                    setErrorMessage(response.message || "Something went wrong.");
                    setButtonClicked(false);

                    setTimeout(() => {
                        setErrorMessage('');
                        setDataErrorMessage(false);
                    }, 1000);
                }
            } catch (error) {
                setDataErrorMessage(true);
                setErrorMessage(error.message || "Something went wrong.");
                setButtonClicked(false);

                setTimeout(() => {
                    setErrorMessage('');
                    setDataErrorMessage(false);
                }, 1000);
            }
        }
    };

    useEffect(() => {
        setPage(0);
    }, [searchQuery]);

    const filteredVehicles = allPunctualityReportData.filter((report) =>
        report.serviceID.toString().includes(searchQuery)
    );

    const displayedVehicles = searchQuery ? filteredVehicles : allPunctualityReportData;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleDownloadReports = async () => {
        setDownloadLoading(true);

        try {
            const payload = {
                host: config.apiEndpoints.punctualityReportOriginDownload.host,
                endPoint: config.apiEndpoints.punctualityReportOriginDownload.url,
                method: "POST",
                body: {
                    ...(selectedOrigin && { origin: selectedOrigin }),
                    ...(selectedDestination && { destination: selectedDestination }),
                    ...(originDate && { date: formatDate(originDate) }),
                },
            };
            const response = await downloadApiCall(payload)
            if (response.status === 400) {
                const errorData = await response.json();
                const errorMessage = errorData.message || "Something went wrong";
                setDataErrorMessage(true);
                console.log("responned error: ", await response)
                setErrorMessage(errorMessage);
                setDownloadLoading(false);

                setTimeout(() => {
                    setErrorMessage('');
                    setDataErrorMessage(false);
                }, 1000);
                return;
            } else {
                const blob = await response.blob();
                const filename = `Punctuality Report ${formatDate(originDate)}.csv`
                const link = document.createElement('a');
                const url = window.URL.createObjectURL(blob);
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                setDataSuccessMessage(true);
                setSuccessMessage("Successfully downloaded");
                setDownloadLoading(false);

                setTimeout(() => {
                    setSuccessMessage('');
                    setDataSuccessMessage(false);
                }, 1000);
            }
        } catch (error) {
            console.log("error", error);
            setDataErrorMessage(true);
            setErrorMessage(error.data || "Something went wrong.");
            setDownloadLoading(false);

            setTimeout(() => {
                setErrorMessage('');
                setDataErrorMessage(false);
            }, 1000);
        }
    }

    return (
        <div>
            <Navbar
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                placeholder="Search service Id..."
                showFilter = {showFilter}
            />
            {
                loading ?
                    <div className="loader-wrapper">
                        <div className="truck-wrapper">
                            <div className="truck">
                                <div className="truck-container"></div>
                                <div className="glases"></div>
                                <div className="bonet"></div>

                                <div className="base"></div>

                                <div className="base-aux"></div>
                                <div className="wheel-back"></div>
                                <div className="wheel-front"></div>

                                <div className="smoke"></div>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <div className='filterDiv'>
                            <div>
                                <Select
                                    options={dayWise}
                                    defaultValue={dayWise[0]}
                                    onChange={(e) => {
                                        setDayWiseData(e.value)
                                        setDayValueError('')
                                        setVehicleWiseData('')
                                        setAllPunctualityReportData([])
                                        // setInputValueNo(null)
                                    }}
                                    styles={{
                                        zIndex: 500,
                                        control: (provided) => ({
                                            ...provided,
                                            padding: '10px 5px',
                                        }),
                                    }}
                                />
                                {renderErrorMessage(dayValueError)}
                            </div>
                            {
                                (dayWiseData === 'Monthly Wise' || dayWiseData === 'Week Wise' || dayWiseData === 'Day Wise') &&
                                (
                                    <div>
                                        <Select
                                            options={vehicleWise}
                                            onChange={(e) => {
                                                setVehicleWiseData(e.value)
                                                setVehicleValueError('')
                                                setVehicleServiceType(e.value)
                                                setStartDate(null)
                                                setEndDate(null)
                                                setSpecificDate(null)
                                                setInputValueNo(null)
                                            }}
                                            placeholder="Select vehicle/Service Id Wise"
                                            styles={{
                                                zIndex: 500,
                                                control: (provided) => ({
                                                    ...provided,
                                                    padding: '10px 5px',
                                                }),
                                            }}
                                        />
                                        {renderErrorMessage(vehicleValueError)}
                                    </div>
                                )}
                            {
                                dayWiseData === 'Day Wise' &&
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Specific Date"
                                            value={specificDate}
                                            onChange={handleSpecificDate}
                                            disableFuture
                                            renderInput={(params) => <TextField {...params} fullWidth />}
                                        />
                                    </LocalizationProvider>
                                    {renderErrorMessage(specificDateError)}
                                </div>
                            }
                            {
                                dayWiseData === "Origin Wise" && (
                                    <>
                                        <div>
                                            <Autocomplete
                                                options={originData}
                                                value={autocompleteOrigin}
                                                className="w-full"
                                                onInputChange={handleOriginInputChange}
                                                onChange={handleOriginValueChange}
                                                getOptionLabel={(option) => option}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select origin"
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                            {renderErrorMessage(originError)}
                                        </div>
                                        <div>
                                            <Autocomplete
                                                options={destinationData}
                                                value={autocompleteDestination}
                                                onInputChange={handleDestinationInputChange}
                                                onChange={handleDestinationValueChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select destination"
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                            {renderErrorMessage(destinationError)}
                                        </div>
                                    </>
                                )
                            }
                            {
                                dayWiseData === 'Origin Wise' &&
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Specific Date"
                                            maxDate={new Date(Date.now() - 86400000)}
                                            value={originDate}
                                            onChange={(date) => setOriginDate(date)}
                                            disableFuture
                                            renderInput={(params) => <TextField {...params} fullWidth />}
                                        />
                                    </LocalizationProvider>
                                    {renderErrorMessage(specificDateError)}
                                </div>
                            }
                            {
                                (dayWiseData === 'Monthly Wise' || dayWiseData === 'Week Wise') &&
                                <div className='datepickerdiv'>
                                    <div>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="Start Date"
                                                value={startDate}
                                                onChange={handleStartDate}
                                                disableFuture
                                                renderInput={(params) => <TextField {...params} fullWidth />}
                                            />
                                        </LocalizationProvider>
                                        {renderErrorMessage(startDateError)}
                                    </div>
                                    <div>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="End Date"
                                                value={endDate}
                                                onChange={handleEndDate}
                                                disableFuture
                                                renderInput={(params) => <TextField {...params} fullWidth />}
                                            />
                                        </LocalizationProvider>
                                        {renderErrorMessage(endDateError)}
                                    </div>
                                </div>
                            }
                            <div>
                                {
                                    vehicleWiseData === "vehicle" && dayWiseData === "Day Wise" &&
                                    <Select
                                        options={vehicleServiceData}
                                        onChange={(e) => {
                                            setInputValueNo(e.value)
                                            setInputValueError('')
                                        }}
                                        placeholder="Select Vehicle Number"
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                padding: '10px 5px',
                                            }),
                                        }}
                                    />
                                }
                                {
                                    vehicleWiseData === "service" && dayWiseData === "Day Wise" &&
                                    <Select
                                        options={vehicleServiceData}
                                        onChange={(e) => {
                                            setInputValueNo(e.value)
                                            setInputValueError('')
                                        }}
                                        placeholder="Select Service Id"
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                padding: '10px 5px',
                                            }),
                                        }}
                                    />
                                }
                                <>
                                    {
                                        vehicleWiseData === "vehicle" && dayWiseData === "Monthly Wise" &&
                                        <TextField
                                            label="Enter Vehicle no"
                                            variant="outlined"
                                            type='text'
                                            onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
                                            onChange={(e) => {
                                                setInputValueNo(e.target.value)
                                                setInputValueError('')
                                            }}
                                        />
                                    }
                                    {
                                        vehicleWiseData === "service" && dayWiseData === "Monthly Wise" &&
                                        <TextField
                                            label='Enter Service Id'
                                            variant="outlined"
                                            type='text'
                                            onInput={(e) => {
                                                const value = e.target.value;
                                                const numericValue = value.replace(/[^0-9]/g, '');
                                                setInputValueNo(numericValue ? Number(numericValue) : '');
                                                setInputValueError('');
                                            }}
                                            value={inputValueNo}
                                        />
                                    }
                                </>
                                {renderErrorMessage(inputValueError)}
                            </div>
                            <Button
                                variant="outlined"
                                style={{
                                    padding: "15px",
                                    backgroundColor: "grey",
                                    color: "white"
                                }}
                                disabled={buttonClicked}
                                onClick={() => handleShowAllReports()}
                                className='btnReport'>{buttonClicked ? "Loading" : "Get Report"}
                            </Button>
                            {
                                allPunctualityReportData.length > 0 && dayWiseData === "Origin Wise" && (
                                    <Button
                                        variant="outlined"
                                        style={{
                                            padding: "15px",
                                            backgroundColor: "grey",
                                            color: "white",
                                            // marginLeft: "10px",
                                        }}
                                        disabled={downloadLoading}
                                        onClick={() => handleDownloadReports()}
                                        className='btnReport'>{downloadLoading ? "Downloading Report" : "Download Report"}
                                    </Button>
                                )
                            }
                        </div>
                        <>
                            {
                                (dayWiseData === "Monthly Wise" || dayWiseData === "Day Wise") &&
                                <MonthDayBasedTable
                                    displayedVehicles={displayedVehicles}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    handlePageChange={handleChangePage}
                                    handleRowsPerPage={handleChangeRowsPerPage}
                                />
                            }
                            {
                                (dayWiseData === "Origin Wise") &&
                                <OriginBasedTable
                                    displayedVehicles={displayedVehicles}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    handlePageChange={handleChangePage}
                                    handleRowsPerPage={handleChangeRowsPerPage}
                                />
                            }
                            {
                                dayWiseData === "Week Wise" && (
                                    <WeekBasedTable
                                        displayedVehicles={displayedVehicles}
                                        page={page}
                                        rowsPerPage={rowsPerPage}
                                        handlePageChange={handleChangePage}
                                        handleRowsPerPage={handleChangeRowsPerPage}
                                    />
                                )
                            }
                        </>
                    </div>
            }
            <>
                {
                    dataSuccessMessage ? (
                        <div style={{ position: "fixed", bottom: "5%", right: "0%", width: "100%", zIndex: "969895" }}>
                            <Success msg={successMessage} />
                        </div>
                    ) : null
                }
                {
                    dataErrorMessage ? (
                        <div style={{ position: "fixed", bottom: "5%", right: "0%", width: "100%", zIndex: "969895" }}>
                            <Error msg={errorMessage} />
                        </div>
                    ) : null
                }
            </>
        </div>
    );
};

export default PunctualityReport;
